export default {
  props: {
    customAttr: {
      type: Function,
      default: () => ''
    },
    options: {
      type: Array
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/MultiSelect/mixins/optionAwareMixin.js